export { VuesaxBoldEye } from "./VuesaxBoldEye";
